import { useContentUsageLimits, useContentUsageLimitsProvider, LimitTypes } from 'content-management-restrictions-lib';
import { useMemo } from 'react';
const usePermissionsLimitData = () => {
  const {
    contentUsageLimitRequestsSucceeded
  } = useContentUsageLimitsProvider();
  const {
    getHasExceededUsageLimit,
    getHasReachedUsageLimit,
    getLimitValue
  } = useContentUsageLimits();
  const limitData = useMemo(() => ({
    hasExceededContentGroupLimit: getHasExceededUsageLimit(LimitTypes.CONTENT_GROUP_LIMIT),
    hasExceededContentObjectLimit: getHasExceededUsageLimit(LimitTypes.CONTENT_OBJECT_LIMIT),
    hasReachedContentObjectLimit: getHasReachedUsageLimit(LimitTypes.CONTENT_OBJECT_LIMIT),
    multiLangGroupSizeLimit: getLimitValue(LimitTypes.CONTENT_OBJECT_MULTI_LANG_GROUP_SIZE_LIMIT)
  }), [getHasExceededUsageLimit, getHasReachedUsageLimit, getLimitValue]);
  return {
    limitData,
    contentUsageLimitRequestsSucceeded
  };
};
export default usePermissionsLimitData;